'use strict';

module.exports = 60 * 1000;